import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from './pagination.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule,
    TranslateModule,
  ],
  declarations: [
    PaginationComponent,
  ],
  entryComponents: [
    PaginationComponent
  ],
  exports: [
    PaginationComponent
  ],
})
export class PaginationModule { }
